const cards = [
  {
    title: '本周最热国产剧情合集',
    desc: '精选本周播放量最高的91国产免费视频剧情片，涵盖都市、悬疑、喜剧等多种类型，部部精彩不容错过。',
    tag: '热门推荐',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20composition%20with%20warm%20red%20and%20deep%20crimson%20tones%2C%20film%20strip%20motif%2C%20dramatic%20lighting%20from%20top%20right%2C%20dark%20atmospheric%20background%2C%20luxurious%20theater%20vibe%2C%20smooth%20gradients%2C%20no%20people%20no%20text%2C%20artistic%20movie%20poster%20aesthetic&width=800&height=500&seq=card-hot-2026&orientation=landscape',
  },
  {
    title: '91传媒视频在线精品推荐',
    desc: '91传媒独家出品的高清短片系列，制作精良、剧情紧凑，为您带来高品质的国产视频在线观看体验。',
    tag: '传媒精选',
    img: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20abstract%20cinema%20design%20with%20amber%20and%20gold%20warm%20gradients%2C%20elegant%20film%20elements%2C%20soft%20glowing%20highlights%2C%20dark%20rich%20background%2C%20professional%20movie%20production%20aesthetic%2C%20no%20people%20no%20text%2C%20luxurious%20theater-inspired%20visual&width=800&height=500&seq=card-media-2026&orientation=landscape',
  },
  {
    title: '每日更新50+高清国产片',
    desc: '编辑团队每日严格筛选，确保入库的每一部91国产免费视频都具备高清画质与优质内容，观影体验不打折扣。',
    tag: '每日上新',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20clean%20abstract%20design%20with%20warm%20coral%20and%20soft%20orange%20gradients%2C%20calendar%20and%20clock%20motifs%20subtle%2C%20fresh%20vibrant%20energy%2C%20dark%20background%20with%20warm%20accents%2C%20cinematic%20feel%2C%20no%20people%20no%20text%2C%20editorial%20style%20composition&width=800&height=500&seq=card-daily-2026&orientation=landscape',
  },
  {
    title: '国产经典老片修复专区',
    desc: '收录91年国产影片视频等经典作品，经过数字修复后高清呈现，重温那些年陪伴我们成长的国产电影。',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20cinematic%20abstract%20design%20with%20sepia%20and%20warm%20golden%20tones%2C%20vintage%20film%20texture%2C%20old%20cinema%20elements%2C%20soft%20glowing%20warm%20light%2C%20dark%20rich%20background%2C%20classic%20movie%20aesthetic%2C%20no%20people%20no%20text%2C%20elegant%20timeless%20feel&width=800&height=500&seq=card-classic-2026&orientation=landscape',
  },
  {
    title: '国产小视频轻松一刻',
    desc: '91国产小视频专区汇集轻松有趣的短片内容，茶余饭后几分钟即可享受欢乐时光，是放松身心的好选择。',
    tag: '轻松短片',
    img: 'https://readdy.ai/api/search-image?query=A%20playful%20lighthearted%20abstract%20cinematic%20design%20with%20warm%20peach%20and%20soft%20gold%20gradients%2C%20bubbly%20energetic%20feel%2C%20modern%20minimalist%20composition%2C%20dark%20background%20with%20warm%20highlights%2C%20short%20video%20theme%2C%20no%20people%20no%20text%2C%20fun%20vibrant%20aesthetic&width=800&height=500&seq=card-short-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            精选专题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-[560px] mx-auto">
            精心策划的国产免费视频专题合集，多维度为您呈现91国产免费视频的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <div
              key={card.title}
              className={`rounded-xl overflow-hidden bg-background-50 border border-background-200/60 transition-all duration-200 hover:-translate-y-0.5 ${
                i === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className={`relative ${i === 0 ? 'h-[240px] md:h-[280px]' : 'h-[180px] md:h-[200px]'} overflow-hidden`}>
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">{card.title}</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}